import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import { toggleSubNav } from '../../../Redux/Actions/ToggleSubnavAction';
import routeRules from '../../../Routes/routeRules';

const menuData = [
  {
    title: 'Copy to use group',
    icon: '',
    link: [
      {
        link: routeRules.usermanagement,
        label: 'Users',
        key: 'users_listing',
      },
      {
        link: routeRules.reportmanagement,
        label: 'Reported Users',
        key: 'reported_users',
      },
      {
        link: routeRules.usersFeedback,
        label: 'Users feedback',
        key: 'users_feedback',
      },
      {
        link: routeRules.inviteFriends,
        label: 'Friends invitations',
        key: 'friends_invitations',
      },
    ],

    label: 'User Management',
    key: 'manage_users',
  },
  {
    title: 'Copy to use desktop',
    icon: '',
    link: routeRules.analytics,
    label: 'Analytics',
    key: 'analytics',
  },
  {
    title: 'Copy to use file-text',
    icon: '',
    link: [
      {
        link: routeRules.PremiumPackage,
        label: 'Premium Packages',
        key: 'manage_premium',
      },
      {
        link: routeRules.BloomPackage,
        label: 'Bloom Packages',
        key: 'manage_bloom',
      },
      {
        link: routeRules.PremiumUser,
        label: 'Premium customers',
        key: 'premium_users',
      },
      {
        link: routeRules.BloomUser,
        label: 'Bloom customers',
        key: 'bloom_users',
      },
      {
        link: routeRules.FreeUser,
        label: 'Complimentary Premium',
        key: 'free_users',
      },
    ],
    label: 'Subscription Management',
    key: 'manage_subscription',
  },
  {
    title: 'Copy to use comments',
    icon: '',
    link: [
      {
        link: routeRules.Supportmanagement,
        label: 'Support',
        key: 'manage_support',
      },
      {
        link: routeRules.messageManagement,
        label: 'Message',
        key: 'manage_message',
      },
    ],
    label: 'Support Management',
    key: 'manage_supports',
  },
  {
    title: 'Copy to use list-alt',
    icon: '',
    link: [
      {
        link: routeRules.contentmanagement,
        label: 'Static Pages',
        key: 'manage_pages',
      },
      {
        link: routeRules.ethnicityManagement,
        label: 'Ethnicity',
        key: 'manage_ethnicity',
      },
      {
        link: routeRules.religionmanagement,
        label: 'Religion',
        key: 'manage_religion',
      },
      {
        link: routeRules.importanceReligionManagement,
        label: 'Importance Religion',
        key: 'manage_importance_religion',
      },
      {
        link: routeRules.relationshipmanagement,
        label: 'Relationship',
        key: 'manage_relationship',
      },
      {
        link: routeRules.interstedmanagement,
        label: 'Interests',
        key: 'manage_intersted',
      },
      {
        link: routeRules.educationmanagement,
        label: 'Manage Education',
        key: 'manage_education',
      },
      {
        link: routeRules.myselfmanagement,
        label: 'Myself',
        key: 'manage_myself',
      },
      {
        link: routeRules.hobbiesmanagement,
        label: 'Hobbies',
        key: 'manage_hobbies',
      },
      {
        link: routeRules.dreamanagement,
        label: 'My Dream',
        key: 'manage_mydream',
      },
      {
        link: routeRules.dreamPartnerManagement,
        label: 'My Dream Partner',
        key: 'manage_dream_partner',
      },
    ],
    label: 'Content Management',
    key: 'manage_content',
  },
  {
    title: 'Copy to use comments',
    icon: '',
    link: [
      /* {
				link: routeRules.noticontent,
				label: 'Notification Content',
				key: 'notification_content',
			}, */
      {
        link: routeRules.PushNotification,
        label: 'Broadcast Notification',
        key: 'push_notification',
      },
    ],
    label: 'Notification Management',
    key: 'manage_notifications',
  },
  {
    title: 'Copy to use group',
    icon: '',
    link: routeRules.InfluencerUser,
    label: 'Influencer Management',
    key: 'manage_influencer_user',
  },
  {
    title: 'Copy to use group',
    icon: '',
    link: routeRules.Referralmanagement,
    label: 'Referral Management',
    key: 'manage_Referral_user',
  },

  {
    title: 'Copy to use group',
    icon: '',
    link: routeRules.profile,
    label: 'Profile',
    key: 'manage_profile',
  },
  {
    title: 'Copy to use group',
    icon: '',
    link: routeRules.appVersion,
    label: 'APP Version',
    key: 'manage_appVersion',
  },
];

class LeftNavigation extends React.Component {
  constructor(props) {
    super(props);

    let sel = this.props.location.pathname;
    if (sel == '/dashboard') {
      sel = '/analytics';
    }
    console.log('uuuuuuuuuuuuuuuuuuuuu', sel);
    this.state = {
      menu: menuData,
      activeLink: sel,
    };
  }

  handleClickMenu = menuItem => {
    this.props.history.replace(menuItem.link);
    console.log('menuItem.link :----->', menuItem.link);
    this.setState(prevState => ({
      ...prevState,
      activeLink: menuItem.link,
    }));
  };

  toggleMenu = (menuItem, i) => {
    let menuClone = [...this.state.menu];
    menuClone[i].open = !menuClone[i].open;
    this.setState({
      menu: menuClone,
      activeLink: menuClone[i].link,
    });
  };

  render() {
    const { menu, activeLink } = this.state;
    console.log('activeLink :=>', activeLink);
    return (
      <div className="dashboard-sidenav-left">
        <div className="dashboard-sidenav-left-menu">
          <div className="app-sidebar sidebar-shadow">
            <div className="scrollbar-sidebar">
              <div className="app-sidebar__inner">
                <ul className="vertical-nav-menu metismenu" onClick={e => e.stopPropagation()}>
                  {menu.map((menuItem, i) => {
                    console.log(this.state.activeLink, 'ooooooooooooo');
                    if (Array.isArray(menuItem.link) && menuItem.link.length > 0) {
                      return (
                        <li
                          key={menuItem.key}
                          onClick={() => this.toggleMenu(menuItem, i)}
                          className={menuItem.open ? 'mm-active' : ''}
                        >
                          <a style={{ cursor: 'pointer' }}>
                            <i className="metismenu-icon fa fa-fw" aria-hidden="true" title={menuItem.title}>
                              {menuItem.icon}
                            </i>
                            {menuItem.label}
                            <i className="metismenu-state-icon pe-7s-angle-down caret-left" />
                          </a>
                          <ul className={menuItem.open ? 'mm-collapse mm-show' : 'mm-collapse'}>
                            {menuItem.link.map((subMenuItem, i) => (
                              <li key={subMenuItem.key} onClick={() => this.handleClickMenu(subMenuItem)}>
                                <a style={{ cursor: 'pointer' }}>
                                  <i className="metismenu-icon pe-7s-display2" />
                                  {subMenuItem.label}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </li>
                      );
                    } else {
                      return (
                        <li key={menuItem.key} onClick={() => this.handleClickMenu(menuItem)}>
                          <a style={{ cursor: 'pointer' }} className={activeLink === menuItem.link ? 'mm-active' : ''}>
                            <i className="metismenu-icon fa fa-fw" title={menuItem.title}>
                              {menuItem.icon}
                            </i>
                            {menuItem.label}
                          </a>
                        </li>
                      );
                    }
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isOpen: state.toggleSubnavReducer.isOpen,
});

export default compose(connect(mapStateToProps, { toggleSubNav }), withRouter)(LeftNavigation);

{
  /* <div className="dashboard-sidenav-left">

<div className="dashboard-sidenav-left-menu">

	<div className="active-link dashboard-sidenav-left-menu-item-default dashboard-sidenav-left-menu-item-default-w">
		<i className="fa fa-user" aria-hidden="true"></i>
		<Link to={routeRules.usermanagement}> User Management </Link>
	</div>
	<div className="dashboard-sidenav-left-menu-item-default dashboard-sidenav-left-menu-item-default-w">
		<i className="fa fa-user" aria-hidden="true"></i>
		<Link to={routeRules.reportmanagement}> User Report Management </Link>
	</div>
	<div className="dashboard-sidenav-left-menu-item-default dashboard-sidenav-left-menu-item-default-w">
		<i className="fa fa-file-o" aria-hidden="true"></i>
		<Link to={routeRules.contentmanagement}> Content Management </Link>
	</div>
	<div className="dashboard-sidenav-left-menu-item-default dashboard-sidenav-left-menu-item-default-w">
		<i className="fa fa-user-circle-o" aria-hidden="true"></i>
		<Link to={routeRules.analytics}>Analytics Management </Link>
	</div>
	<div className="dashboard-sidenav-left-menu-item-default dashboard-sidenav-left-menu-item-default-w">
		<i className="fa fa-user-circle-o" aria-hidden="true"></i>
		<Link to={routeRules.Supportmanagement}>Support Management </Link>
	</div>
	<div className="dashboard-sidenav-left-menu-item-default dashboard-sidenav-left-menu-item-default-w">
		<i className="fa fa-user-circle-o" aria-hidden="true"></i>
		<Link to={routeRules.messageManagement}>Message Management </Link>
	</div>

	<div className="dashboard-sidenav-left-menu-item-default dashboard-sidenav-left-menu-item-default-w">
		<i className="fa fa-user-circle-o" aria-hidden="true"></i>
		<Link to={routeRules.noticontent}>Notification Content </Link>
	</div>

	<div className="dashboard-sidenav-left-menu-item-default dashboard-sidenav-left-menu-item-default-w">
		<i className="fa fa-user-circle-o" aria-hidden="true"></i>
		<Link to={routeRules.PushNotification}>Push Notification</Link>
	</div>
	<div className="dashboard-sidenav-left-menu-item-default dashboard-sidenav-left-menu-item-default-w">
		<i className="fa fa-user" aria-hidden="true"></i>
		<Link to={routeRules.InfluencerUser}>Influencer User Management</Link>
	</div>
	<div className="dashboard-sidenav-left-menu-item-default dashboard-sidenav-left-menu-item-default-w">
		<i className="fa fa-user" aria-hidden="true"></i>
		<Link to={routeRules.PremiumPackage}>Premium Package Management</Link>
	</div>
	<div className="dashboard-sidenav-left-menu-item-default dashboard-sidenav-left-menu-item-default-w">
		<i className="fa fa-user" aria-hidden="true"></i>
		<Link to={routeRules.BloomPackage}>Bloom Package Management</Link>
	</div>
	<div className="dashboard-sidenav-left-menu-item-default dashboard-sidenav-left-menu-item-default-w">
		<i className="fa fa-user" aria-hidden="true"></i>
		<Link to={routeRules.PremiumUser}>Premium Users</Link>
	</div>
	<div className="dashboard-sidenav-left-menu-item-default dashboard-sidenav-left-menu-item-default-w">
		<i className="fa fa-user" aria-hidden="true"></i>
		<Link to={routeRules.BloomUser}>Bloom Users</Link>
	</div>
	<div className="dashboard-sidenav-left-menu-item-default dashboard-sidenav-left-menu-item-default-w">
		<i className="fa fa-user" aria-hidden="true"></i>
		<Link to={routeRules.FreeUser}>Free Users</Link>
	</div>

	<div className={`dashboard-sidenav-left-menu-item-default  `} onClick={toggleSubNav}>
		<i className="fa fa-file-o" aria-hidden="true"></i>
		<Link >Master Content</Link>
	</div>
	<div id="demo" className={`${isOpen ? "d-block" : "d-none"}`}>
		<div className={`dashboard-sidenav-left-menu-item-default bg-white`}>
			<i className="fa fa-user" aria-hidden="true"></i>
			<Link
				to={routeRules.religionmanagement}
				className={`left-navigation-sub-m ${
					this.props.location.pathname === "/religionmanagement"
						? "green-text"
						: null
					}`}
			>
				Religion Management
			 </Link>
		</div>
		<div className={`dashboard-sidenav-left-menu-item-default bg-white`}>
			<i className="fa fa-user" aria-hidden="true"></i>
			<Link
				to={routeRules.importanceReligionManagement}
				className={`left-navigation-sub-m ${
					this.props.location.pathname === "/importanceReligionManagement"
						? "green-text"
						: null
					}`}
			>
				Importance Religion Management
	</Link>
		</div>
		<div className={`dashboard-sidenav-left-menu-item-default bg-white`}>
			<i className="fa fa-user" aria-hidden="true"></i>
			<Link
				to={routeRules.educationmanagement}
				className={`left-navigation-sub-m ${
					this.props.location.pathname === "/educationmanagement"
						? "green-text"
						: null
					}`}
			>
				Education Management
  </Link>
		</div>
		<div className={`dashboard-sidenav-left-menu-item-default bg-white`}>
			<i className="fa fa-user" aria-hidden="true"></i>
			<Link
				to={routeRules.myselfmanagement}
				className={`left-navigation-sub-m ${
					this.props.location.pathname === "/myselfmanagement"
						? "green-text"
						: null
					}`}
			>
				MySelf Management
  </Link>
		</div>
		<div className={`dashboard-sidenav-left-menu-item-default bg-white`}>
			<i className="fa fa-user" aria-hidden="true"></i>
			<Link
				to={routeRules.interstedmanagement}
				className={`left-navigation-sub-m ${
					this.props.location.pathname === "/interstedmanagement"
						? "green-text"
						: null
					}`}
			>
				Intersted Management
  </Link>
		</div>
		<div className={`dashboard-sidenav-left-menu-item-default bg-white`}>
			<i className="fa fa-user" aria-hidden="true"></i>
			<Link
				to={routeRules.relationshipmanagement}
				className={`left-navigation-sub-m ${
					this.props.location.pathname === "/relationshipmanagement"
						? "green-text"
						: null
					}`}
			>
				Relationship Management
  </Link>
		</div>
		<div className={`dashboard-sidenav-left-menu-item-default bg-white`}>
			<i className="fa fa-user" aria-hidden="true"></i>
			<Link
				to={routeRules.hobbiesmanagement}
				className={`left-navigation-sub-m ${
					this.props.location.pathname === "/hobbiesmanagement"
						? "green-text"
						: null
					}`}
			>
				Hobbies Management
  </Link>
		</div>
		<div className={`dashboard-sidenav-left-menu-item-default bg-white`}>
			<i className="fa fa-user" aria-hidden="true"></i>
			<Link
				to={routeRules.dreamanagement}
				className={`left-navigation-sub-m ${
					this.props.location.pathname === "/dreamanagement"
						? "green-text"
						: null
					}`}
			>
				Dream Management
	</Link>
		</div>
		<div className={`dashboard-sidenav-left-menu-item-default bg-white`}>
			<i className="fa fa-user" aria-hidden="true"></i>
			<Link
				to={routeRules.dreamPartnerManagement}
				className={`left-navigation-sub-m ${
					this.props.location.pathname === "/dreamPartnerManagement"
						? "green-text"
						: null
					}`}
			>
				Dream Partner Management
	</Link>
		</div>
		<div className={`dashboard-sidenav-left-menu-item-default bg-white`}>
			<i className="fa fa-user" aria-hidden="true"></i>
			<Link
				to={routeRules.ethnicityManagement}
				className={`left-navigation-sub-m ${
					this.props.location.pathname === "/ethnicityManagement"
						? "green-text"
						: null
					}`}
			>
				Ethnicity Management
	</Link>
		</div>

	</div>
	<div className="dashboard-sidenav-left-menu-item-default dashboard-sidenav-left-menu-item-default-w">
		<i className="fa fa-cog" aria-hidden="true"></i>
		<Link to={routeRules.profile}>Profile </Link>
	</div>
</div>
</div > */
}
